/**
 * Returns a 'pluralized' string.
 * @param singularTerm {String} Singular item term
 * @param amount {Number} If 1 is passed in, the term will not be pluralized
 */
export function pluralize(singularTerm: string, amount: number): string {
  if (amount <= 1) {
    return singularTerm;
  }

  return singularTerm + 's';
}

/**
 * Sanitizes a string using the built in client side browser HTML
 * sanitizer
 * @param string
 */
export function sanitize(string: string): string {
  const element = document.createElement('p');
  const textNode = document.createTextNode(string);
  element.appendChild(textNode);

  return element.innerHTML;
}
